import React, { Fragment } from 'react';
import Filter from "../filter/filter-component";
import Spinner from "../spinner/spinner-component";



const Filters = (
  {
    filters,
    toggleFilter,
    deleteFilter,
    loading,
    toggleIsScore,
    error
  }
  ) => {
  return (
    <div className="filters_component" style={{textAlign: loading ? 'center' : 'left'}}>
      {
        error ?
          <div style={{textAlign: 'center'}}>{ error }</div>
          :
          null
      }
      {
        !loading && !error ?
          filters.map((filter, i) =>
            <Filter
              filters={filter.filters}
              isScore={filter.isScore}
              key={i}
              filterName={filter.filter_name}
              toggle={toggleFilter}
              containerIndex={i}
              deleteFilter={deleteFilter}
              toggleIsScore={() => toggleIsScore(i)}
            />)
          :
          <Spinner
            loading={loading}
            left="110px"
            top="250px"
            fontSize="18px"
          />
      }
    </div>
  )
};

export default Filters;


// WEBPACK FOOTER //
// ./src/components/filters/filters-component.js